"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$ = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$outboundSchema = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$inboundSchema = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$ = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$outboundSchema = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$inboundSchema = void 0;
exports.getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurityToJSON = getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurityToJSON;
exports.getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurityFromJSON = getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurityFromJSON;
exports.getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequestToJSON = getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequestToJSON;
exports.getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequestFromJSON = getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$;
(function (GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$) {
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$inboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$.inboundSchema = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$inboundSchema;
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$outboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$.outboundSchema = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$outboundSchema;
})(GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$ || (exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$ = GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$ = {}));
function getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurityToJSON(getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity) {
    return JSON.stringify(exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$outboundSchema
        .parse(getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity));
}
function getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetSecurity' from JSON`);
}
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$inboundSchema = z.object({
    "filter[end_date]": z.string().optional(),
    "filter[start_date]": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_date]": "filterEndDate",
        "filter[start_date]": "filterStartDate",
    });
});
/** @internal */
exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$outboundSchema = z.object({
    filterEndDate: z.string().optional(),
    filterStartDate: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndDate: "filter[end_date]",
        filterStartDate: "filter[start_date]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$;
(function (GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$) {
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$inboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$.inboundSchema = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$inboundSchema;
    /** @deprecated use `GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$outboundSchema` instead. */
    GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$.outboundSchema = exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$outboundSchema;
})(GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$ || (exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$ = GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$ = {}));
function getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequestToJSON(getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest) {
    return JSON.stringify(exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$outboundSchema
        .parse(getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest));
}
function getNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetNationalAverageTimeOnMarketStatsSalesNationalAverageTimeOnMarketGetRequest' from JSON`);
}
//# sourceMappingURL=getnationalaveragetimeonmarketstatssalesnationalaveragetimeonmarketget.js.map